import React, { Component } from "react";
import { KnightGamesCTA } from "./knight-games-cta";
import { Outlet } from "react-router";

export default class KnightGames extends Component {
	render() {
		return (
			<div className="container container_games_knight-games">
				<Outlet />
				<div className="game-banner">
					<a className="game-title" href={"https://store.steampowered.com/app/3752150/Knight_Games/"} target="_blank" rel="noreferrer">
						<img src="/assets/KG/KG Logo.png" alt="Knight Games Logo" className="knight-games-logo" />
					</a>
					<br />
					<span className="description">
						<h2 className="title-tagline">Stayupol Kingdom awaits your arrival</h2>
						<h2 className="coming-soon">
							A medieval party game
							<br />
							coming soon to
							<a href="https://store.steampowered.com/app/3752150/Knight_Games/" target="_blank" rel="noreferrer">
								<img className="steam-logo" alt="Steam logo" src="/assets/icons/Steam_Logo.png" />
							</a>
						</h2>
					</span>
					{/* <span className="description">
						<h2 className="title-tagline">Does your squad have what it takes?</h2>
						<h2 className="coming-soon">
							An extreme co-op party game
							<br />
							coming soon to
							<a href="https://store.steampowered.com/app/3752150/Knight_Games/" target="_blank" rel="noreferrer">
								<img className="steam-logo" alt="Steam logo" src="/assets/icons/Steam_Logo.png" />
							</a>
						</h2>
					</span> */}
				</div>
				<KnightGamesCTA />
				{/* <div className="content-section black-grey">
					<div className="content-section_text">
						<h2>
							A game where running errands&nbsp;
							<br />
							is an extreme sport.
						</h2>
						<ul>
							<li>
								<i className="far fa-check-square" />
								<div className="checklist-item">Race around the city with your friends</div>
							</li>
							<li>
								<i className="far fa-check-square" />
								<div className="checklist-item">Divide and conquer in the grocery store</div>
							</li>
							<li>
								<i className="far fa-check-square" />
								<div className="checklist-item">Drop by the bank on your way to class</div>
							</li>
							<li>
								<i className="far fa-check-square" />
								<div className="checklist-item">Leave the barber shop mid-haircut to drive your friend to work</div>
							</li>
							<li>
								<i className="far fa-square" />
								<div className="checklist-item">Check off your to-do list before closing time</div>
							</li>
						</ul>
					</div>
				</div> */}
				{/* <KnightGamesCTA /> */}
				{/* <div className="content-section cta blue">
					<h2>
						There's so much to do and so little time. <br />
						Does your squad have what it takes?
					</h2>
				</div> */}
			</div>
		);
	}
}
